import { createEntityAdapter } from "@reduxjs/toolkit";
import { MediaWithLoadingStatus } from "@shared/models/media";

export const mediaEntityAdapter = createEntityAdapter<MediaWithLoadingStatus>({
  selectId: ({ id }) => id,
});
